import './style.scss'
import { initChrome } from './js/chrome.js'
import { Quiz } from './js/quiz.js'
import { initCarousels } from './js/carousel.js'
import { initMenu } from './js/menu.js'

// Disable browser scroll restoration before anything else
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
}

// Initialize quiz and carousels on DOM ready
function init() {
    // First: the quiz measures screen offsets as soon as it is constructed, and
    // those depend on the reserved band being the right size.
    initChrome()

    const quizEl = document.querySelector('.quiz')
    let quiz = null
    if (quizEl) {
        quiz = new Quiz()
    }
    initCarousels()
    initMenu(quiz)
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
} else {
    init()
}